import type { SpendCategoryType } from '/index';

export const purchasedGoodsAndServicesSpendCategories: SpendCategoryType[] = [
  {
    name: null,
    isPlaceholder: true,
    displayName: 'Select a spend category',
  },
  { name: 'agriculture', displayName: 'Agriculture, forestry and fishing' },
  { name: 'mining', displayName: 'Mining and quarrying' },
  { name: 'manufacturing', displayName: 'Manufacturing' },
  { name: 'construction', displayName: 'Construction' },
  { name: 'electricity', displayName: 'Electricity, gas, steam and air conditioning supply' },
  { name: 'water', displayName: 'Water supply, sewerage, waste management and remediation activities' },
  { name: 'wholeSale', displayName: 'Wholesale and retail trade' },
  { name: 'repairVehicles', displayName: 'Repair of vehicles' },
  { name: 'transport', displayName: 'Transport and storage' },
  { name: 'accommodation', displayName: 'Accommodation and food service activities' },
  { name: 'information', displayName: 'Information and communication' },
  { name: 'finance', displayName: 'Financial and insurance activities' },
  { name: 'realEstate', displayName: 'Real estate activities' },
  { name: 'professional', displayName: 'Professional, scientific and technical activities' },
  { name: 'admin', displayName: 'Administrative and support service activities' },
  { name: 'public', displayName: 'Public administration and defence' },
  { name: 'socialSecurity', displayName: 'Social security and insurance activities' },
  { name: 'education', displayName: 'Education' },
  { name: 'health', displayName: 'Human health and social work activities' },
  { name: 'arts', displayName: 'Arts, entertainment and recreation' },
  { name: 'other', displayName: 'Other service activities' },
  { name: 'households', displayName: 'Activities of households as employers' },
  { name: 'undifferentiated', displayName: 'Household undifferentiated goods and services' },
];
